import { useState, useEffect } from "react";
import axios from "axios";
import swal from "sweetalert";
import { MovieModal } from "../../components";
import "../admin-dashboard/Dashboard.css";
import "./categoryPage.css";
import "../../components/carousel/carousel.css";
import { Footer, Landingpagenav } from "../../widgets";
import { FiPlay } from "react-icons/fi";

const CategoryPage = () => {
  const [genres, setGenre] = useState([]);

  useEffect(() => {
    const getGenre = async () => {
      const result = await axios(
        `https://rewind-test.herokuapp.com/category/all`
      );

      setGenre(result.data.message);
    };
    getGenre();
  }, []);

  const [movies, setMovies] = useState([]);

  const getMovies = async (category) => {
    const result = await axios(
      `https://rewind-test.herokuapp.com/movies/${category}/movies`
    );

    if (result.data.message === "No movies in this category") {
      swal({
        icon: "warning",
        text: "No movies in this category",
        timer: 800,
        button: false,
      });
    } else {
      setMovies(result.data.message);
      document.getElementById("allMovies").style.display = "none";
    }
  };

  const [allMovies, setAllMovies] = useState([]);

  useEffect(() => {
    const getAllMovies = async () => {
      const result = await axios(`https://rewind-test.herokuapp.com/movies`);

      setAllMovies(result.data.message);
    };
    getAllMovies();
  }, []);

  const [movieModal, setMovieModal] = useState(false);
  const [selectedMovie, setSelectedMovie] = useState(null);

  const toggleMovieModal = (e, movie) => {
    setMovieModal((prev) => !prev);
    setSelectedMovie(movie);
  };

  return (
    <>
      <Landingpagenav />
      <div className="prac-main">
        <ul className="category-select">
          {genres.map((genre) => (
            <li
              key={genre._id}
              name="category"
              onClick={() => getMovies(genre.title)}
            >
              {genre.title}
            </li>
          ))}
        </ul>
        <section className="recent-upload-container category-container" id="allMovies">
          {allMovies.map((movie) => (
            <div
              key={movie._id}
              className="recent-upload-content-container"
              data-aos="fade-up"
              data-aos-duration="1500"
            >
              <section className="movie-poster">
                <img src={movie.coverpics_url} alt="poster" />
                <span className="movie-poster-overlay">
                  <button onClick={(e) => toggleMovieModal(e, movie)}>
                    <FiPlay />
                  </button>
                </span>
              </section>
              <div className="recent-movie-details-container">
                <h5>{movie.title}</h5>
                <ul className="recent-movie-details">
                  <li>{movie.release_date}</li>
                  <li>{movie.category}</li>
                  <li>{movie.length}</li>
                </ul>
              </div>
            </div>
          ))}
          <MovieModal
            movieModal={movieModal}
            selectedMovie={selectedMovie}
            setMovieModal={setMovieModal}
          />
        </section>
        <section className="recent-upload-container category-container">
          {movies.map((movie) => (
            <div
              key={movie._id}
              className="recent-upload-content-container"
              data-aos="fade-up"
              data-aos-duration="1500"
            >
              <section className="movie-poster">
                <img src={movie.coverpics_url} alt="poster" />
                <span className="movie-poster-overlay">
                  <button onClick={(e) => toggleMovieModal(e, movie)}>
                    <FiPlay />
                  </button>
                </span>
              </section>
              <div className="recent-movie-details-container">
                <h5>{movie.title}</h5>
                <ul className="recent-movie-details">
                  <li>{movie.release_date}</li>
                  <li>{movie.category}</li>
                  <li>{movie.length}</li>
                </ul>
              </div>
            </div>
          ))}
          <MovieModal
            movieModal={movieModal}
            selectedMovie={selectedMovie}
            setMovieModal={setMovieModal}
          />
        </section>
      </div>
      <Footer />
    </>
  );
};

export { CategoryPage };
